import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const boxClass = tone === 'dark' ? 'bg-navy-deep text-gold-light border-white/10' : 'bg-white text-navy border-navy/10';
  return <div className="flex flex-col items-center gap-2" data-id="element-66" data-mp="10dmw5ewpi54u">
      <p className={`flex items-center gap-1.5 text-[11px] sm:text-xs font-semibold uppercase tracking-[0.18em] ${tone === 'dark' ? 'text-white/70' : 'text-navy/60'}`} data-id="element-67" data-mp="15b68uadra9uo">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="t2lkb9iwnk1q" />
        La oferta expira en
      </p>
      <div className="flex items-center gap-2" role="timer" aria-live="off" data-id="element-69" data-mp="17rhqf11eimzp">
        {[{
        v: hours,
        l: 'Horas'
      }, {
        v: minutes,
        l: 'Min'
      }, {
        v: seconds,
        l: 'Seg'
      }].map(unit => <div key={unit.l} className={`flex min-w-[62px] flex-col items-center rounded-xl border px-3 py-2 ${boxClass}`} data-id="element-70" data-mp="f3dl4gmqsbxj">
            <span className="font-display text-2xl sm:text-3xl font-bold tabular-nums leading-none" data-id="element-71" data-mp="o30hup4j0tk9">
              {pad(unit.v)}
            </span>
            <span className={`mt-1 text-[9px] font-semibold uppercase tracking-[0.15em] ${tone === 'dark' ? 'text-white/50' : 'text-navy/45'}`} data-id="element-72" data-mp="k0m42jfpsjzu">
              {unit.l}
            </span>
          </div>)}
      </div>
    </div>;
}